export class ApiendPointsPermission {
    //Summary
    //Get all the permissions
    getPermissionsApiUrl = 'api/Permissions/GetPermissionsList';

    //Summary
    //Create new permission
    createPermissionApiUrl = 'api/Permissions/CreatePermissions';

    //Summary
    //update permissions.
    updatePermissionApiUrl = 'api/Permissions/UpdatePermissions';

    //Summary
    //delete permissions.
    deletePermissionApiUrl = 'api/Permissions/DeletePermissions';

    getModuleList = "api/Permissions/GetModulesList";
}
